import React, { memo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { REDIRECTION_ROUTES_ENUM, REDIRECTION_ROUTES_KEYS } from 'constants/routes';
import { IAuthState, IRootReducer } from 'types/reducers';

import notFoundImg from 'assets/images/page-statuses/404.svg';
import 'assets/scss/pages/page-status.scss';
import { DxLink } from 'components';
import { isKnownRoute } from '../../services/utils/routeHelper';

const PageNotFound = () => {
    const { pathname } = useLocation();
    const auth = useSelector<IRootReducer, IAuthState>((state) => state.auth);

    if (REDIRECTION_ROUTES_KEYS.includes(pathname)) {
        return <Navigate to={REDIRECTION_ROUTES_ENUM[pathname]} replace={true} />;
    }
    if (!auth.isLoggedIn && isKnownRoute(pathname, true)) {
        return <Navigate to={''} replace={true} />;
    } else if (auth.isLoggedIn && isKnownRoute(pathname, false)) {
        return <Navigate to={''} replace={true} />;
    }

    return (
        // FIX NOT FOUND LAYOUT
        <div className="page-status">
            <div className="page-status-content">
                <img className="page-status-img" src={notFoundImg} alt="Page not found" width={698} height={316} />
                <h1 className="page-status-title">Sorry, the Page Not Found.</h1>
                <p className="page-status-desc">The link you followed probably broken or the page has been removed.</p>
                <DxLink to={'/'} appearance="link">
                    Go to Home Page
                </DxLink>
            </div>
        </div>
    );
};

export default memo(PageNotFound);
